export const getRate = (item, pros, cons) => {
    const rate1 = {
        rate: 1,
        text: `Это значит, что стоит исключить продукт ${item.name} из рациона или свести его употребление к незначительному количеству, данный продукт несет больше вреда организму, чем пользы`
    }

    const rate2 = {
        rate: 2,
        text: `Это значит, что требуется максимально ограничить употребление продукта ${item.name} или заменить его на более натуральный и полезный аналог`
    }

    const rate3 = {
        rate: 3,
        text: `Это значит, что употреблять продукт ${item.name} стоит в меру, учитывая его негативное и позитивное влияние на организм, соблюдая при этом норму калорий и макронутриентов рациона`
    }

    const rate4 = {
        rate: 4,
        text: `Это значит, что продукт ${item.name} несет пользу организму и обладает высокой пищевой ценностью, имеет незначительные противопоказания, связанные с индивидуальной непереносимостью компонентов`
    }

    const rate5 = {
        rate: 5,
        text: `Это значит, что продукт ${item.name} идеально сбаланчирован по макронутриентам и микронутриентам и обязательно должен быть включен в рацион на регулярной основе`
    }

    if (cons.includes('содержание алкоголя')) {
        return rate1
    }

    if (cons.length >= 4) {
        return rate1
    }

    if (cons.includes('высокое содержание насыщенных жирных кислот') || cons.includes('содержание трансжиров')) {
        return rate2
    }

    if (cons.length >= 3) {
        return rate2
    }

    let consFor4 = [
        'высокое содержание жиров', 'высокое содержание простых сахаров', 'низкое содержание белка', 'высокую калорийность', 'содержание лактозы (при индивидуальной непереносимости)'
    ]

    let consFind4 = cons.filter(item => consFor4.includes(item))

    if (consFind4.length == 1) {
        return rate4
    }

    let consFor3 = [
        'высокое содержание жиров', 'высокое содержание простых сахаров', 'низкое содержание белка', 'высокую калорийность', 'содержание лактозы (при индивидуальной непереносимости)', 'низкое содержание витаминов', 'высокое содержание натрия', 'продукт является ультра-обработанным'
    ]

    let consFind3 = cons.filter(item => consFor3.includes(item))

    if (consFind3.length == 2 || consFind3.length == 1) {
        return rate3
    }

    if (cons.length == 0) {
        return rate5
    }

    return {
        rate: 'не определен',
        text: 'не определен'
    };
}
